import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { MessageCard } from '@biome-design-system/ui/MessageCard';

export const StyledMessageCard = styled(MessageCard)`
  @media (min-width: ${fromTheme('screen_medium')}) {
    grid-template-columns: 128px 1fr auto;
  }
`;
